export enum PageNames {
    ClientDraperyOrder = "ClientDraperyOrder",
    MyShop = "MyShop"
}
